import { IonButton, IonButtons, IonCol, IonContent, IonDatetime, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonPopover, IonRow, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBack, calendarOutline, timeOutline } from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import './Agendamento.css';

type Props = {
  closeAction: Function;
  closeActionSimple: Function;
  initialData?: string;
  initialHora?: string;
}

const Agendamento: React.FC<Props> = (props: Props) => {

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [dataAgendamento, setDataAgendamento] = useState(props.initialData || "");

  // Inicializar hora com minutos arredondados para múltiplo de 10
  const getHoraInicialArredondada = () => {
    const now = new Date();
    const minutos = now.getMinutes();
    const minutosArredondados = Math.ceil(minutos / 10) * 10;
    now.setMinutes(minutosArredondados);
    now.setSeconds(0);
    now.setMilliseconds(0);

    // Ajustar para o fuso horário local antes de converter para ISO
    const offsetMs = now.getTimezoneOffset() * 60000;
    const localTime = new Date(now.getTime() - offsetMs);
    return localTime.toISOString();
  };

  const [horaAgendamento, setHoraAgendamento] = useState(props.initialHora || "");

  // Estados para controlar popovers
  const [showPopoverData, setShowPopoverData] = useState(false);
  const [showPopoverHora, setShowPopoverHora] = useState(false);

  // Estados temporários para edição
  const [tempDataAgendamento, setTempDataAgendamento] = useState("");
  const [tempHoraAgendamento, setTempHoraAgendamento] = useState("");

  const popoverDateRef = useRef<HTMLIonPopoverElement>(null);
  const popoverTimeRef = useRef<HTMLIonPopoverElement>(null);

  // Função para formatar a data no padrão brasileiro
  function formatarData(isoDate: string): string {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const ano = date.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  // Função para formatar a hora
  function formatarHora(isoTime: string): string {
    if (!isoTime) return "";
    // Extrair a parte da hora do formato ISO (2025-12-01T18:10)
    const timePart = isoTime.includes('T') ? isoTime.split('T')[1] : isoTime;
    const [hora, minuto] = timePart.split(':');
    return `${hora}:${minuto}`;
  }

  return (
    <>

      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => props.closeActionSimple()} />
          </IonButtons>
          <IonTitle>Data do Pedido</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={false}>

        {/* <div className="agendamento-titulo1">
          Quando deseja receber seu pedido?
        </div> */}

        <>
          <div className="agendamento-titulo2">
            Selecione a <span className="agendamento-whatsapp-text">data e hora</span> para agendar
          </div>

          <IonItem
            lines="none"
            className="input-item"
            button
            onClick={(e) => {
              popoverDateRef.current!.event = e;
              setTempDataAgendamento(dataAgendamento); // Inicializa estado temporário
              setShowPopoverData(true);
            }}
          >
            <IonIcon slot="start" icon={calendarOutline} />
            <IonInput
              value={dataAgendamento ? formatarData(dataAgendamento) : ""}
              placeholder="Selecione a data"
              readonly
            ></IonInput>
          </IonItem>

          <IonPopover
            ref={popoverDateRef}
            isOpen={showPopoverData}
            onDidDismiss={() => setShowPopoverData(false)}
          >
            <IonContent>
              <IonDatetime
                presentation="date"
                locale="pt-BR"
                value={tempDataAgendamento}
                onIonChange={(e: any) => {
                  if (e.detail.value) {
                    setTempDataAgendamento(e.detail.value);
                  }
                }}
                min={new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString()}
                max={new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000) + (365 * 24 * 60 * 60 * 1000)).toISOString()}
              />
            </IonContent>

            <IonFooter className="ion-no-border">
              <IonToolbar>
                <IonButtons slot="end">
                  <IonButton onClick={() => {
                    setTempDataAgendamento(""); // Limpa temporário
                    setShowPopoverData(false);
                  }}>
                    Cancelar
                  </IonButton>
                </IonButtons>
                <IonButtons slot="end">
                  <IonButton strong onClick={() => {
                    setDataAgendamento(tempDataAgendamento); // Confirma mudança
                    setShowPopoverData(false);
                  }}>
                    Confirmar
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonFooter>
          </IonPopover>

          <IonItem
            lines="none"
            className="input-item"
            button
            onClick={(e) => {
              popoverTimeRef.current!.event = e;
              setTempHoraAgendamento(horaAgendamento || getHoraInicialArredondada());
              setShowPopoverHora(true);
            }}
          >
            <IonIcon slot="start" icon={timeOutline} />
            <IonInput
              value={horaAgendamento ? formatarHora(horaAgendamento) : ""}
              placeholder="Selecione a hora"
              readonly
            />
          </IonItem>

          <IonPopover
            ref={popoverTimeRef}
            isOpen={showPopoverHora}
            onDidDismiss={() => setShowPopoverHora(false)}
          >
            <IonContent>
              <IonDatetime
                presentation="time"
                locale="pt-BR"
                minuteValues={"0,10,20,30,40,50"}
                value={tempHoraAgendamento}
                onIonChange={(e: any) => {
                  if (e.detail.value) {
                    setTempHoraAgendamento(e.detail.value);
                  }
                }}
              />
            </IonContent>

            <IonFooter className="ion-no-border">
              <IonToolbar>
                <IonButtons slot="end">
                  <IonButton onClick={() => {
                    setTempHoraAgendamento(""); // Limpa temporário
                    setShowPopoverHora(false);
                  }}>
                    Cancelar
                  </IonButton>
                </IonButtons>
                <IonButtons slot="end">
                  <IonButton strong onClick={() => {
                    setHoraAgendamento(tempHoraAgendamento); // Confirma mudança
                    setShowPopoverHora(false);
                  }}>
                    Confirmar
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonFooter>
          </IonPopover>
        </>


        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

      </IonContent>

      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonGrid>
            <IonRow>
              <IonCol>
                <IonButton fill='clear' color="tertiary"
                  style={{ height: "46px", fontSize: "18px" }}
                  onClick={async () => {
                    props.closeAction("", "", "");
                  }}
                  expand="block"
                  type="submit"
                  hidden={props.initialData == ""}
                >
                  Cancelar Agendamento
                </IonButton>
                <IonButton
                  style={{ height: "46px", fontSize: "18px", backgroundColor: "#4CAF50", color: "#fff" }}
                  onClick={async () => {


                    if (!dataAgendamento) {
                      setTextToast("Selecione a data de entrega.");
                      setShowToast(true);
                      return;
                    }

                    if (!horaAgendamento) {
                      setTextToast("Selecione a hora de entrega.");
                      setShowToast(true);
                      return;
                    }

                    // Validar se a data/hora não é no passado

                    // Criar objeto Date a partir da string ISO da data (converte UTC para Local automaticamente)
                    const dataObj = new Date(dataAgendamento);
                    const ano = dataObj.getFullYear();
                    const mes = dataObj.getMonth(); // 0-11
                    const dia = dataObj.getDate();

                    // Extrair HH:mm da hora selecionada
                    let hora = 0;
                    let minuto = 0;

                    if (horaAgendamento.includes('T')) {
                      // Extrair HH:mm diretamente da string ISO para evitar conversão de fuso horário
                      // O IonDatetime retorna algo como "2025-12-03T22:30:00" (às vezes com Z, às vezes sem)
                      // Queremos apenas os números visuais
                      const timePart = horaAgendamento.split('T')[1];
                      const [h, m] = timePart.split(':');
                      hora = parseInt(h);
                      minuto = parseInt(m);
                    } else {
                      // Se for apenas HH:mm
                      const [h, m] = horaAgendamento.split(':').map(Number);
                      hora = h;
                      minuto = m;
                    }

                    // Criar data final combinada no fuso local
                    const dataHoraSelecionada = new Date(ano, mes, dia, hora, minuto);

                    const agora = new Date();
                    // Zerar segundos para comparação justa
                    agora.setSeconds(0);
                    agora.setMilliseconds(0);

                    console.log("Data String:", dataAgendamento);
                    console.log("Data Local Interpretada:", dataHoraSelecionada);
                    console.log("Agora:", agora);

                    if (dataHoraSelecionada < agora) {
                      setTextToast("A data de agendamento deve ser futura.");
                      setShowToast(true);
                      return;
                    }

                    props.closeAction(dataAgendamento, horaAgendamento, "AGENDADO");


                  }}
                  expand="block"
                  type="submit"
                >
                  Agendar
                </IonButton>

              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>
      </IonFooter>


    </>
  );
};

export default ({ closeAction, closeActionSimple, initialData, initialHora }: { closeAction: Function, closeActionSimple: Function, initialData?: string, initialHora?: string }) => (
  <Agendamento closeAction={closeAction} closeActionSimple={closeActionSimple} initialData={initialData} initialHora={initialHora}>
  </Agendamento>
)
